<template>
    <div class="Rewards" v-Loading="loading">
        <div class="rewards-yue flexible">
            <img class="img_rewards" src="@/assets/poctetTv/rewadrs/bg_cai@2x.png"/>
        </div>
        <div class="rewards-con">
            <div class="rewards-title">
                <img src="@/assets/poctetTv/rewadrs/img_title1@2x.png"/>
            </div>
            <div class="rewards-list flexible flex-wrap">
                <div class="rewards-item"
                     v-for="(item) in checkInInfo.signList" :class="item.status==1?'Check-in-item':item.status==2?'Checked-item':item.status==4?'Recheck-item':item.status==5?'Recheck-in-item':'Wait-item'"
                     @click="$event.currentTarget.disabled ? '' : goCheck(item)" v-preventReClick
                ><!--Check-in-item-->
                    <div class="rewards-day f22 f-fwb">Day{{item.day}}</div>
                    <div class="rewards-money">{{item.awardIntroduction}}</div>
                    <div>
                        <img v-if="item.day==2||item.day==5" class="ic_gift mt10" src="@/assets/poctetTv/rewadrs/ic_gift.png"/>
                        <img v-else-if="item.status==2" class="img_bonus mt10" src="@/assets/poctetTv/rewadrs/ic_bonus.png"/>
                        <img v-else class="ic_bonus" src="@/assets/poctetTv/rewadrs/img_bonus.png"/>

                    </div>
                    <div class="rewards-status">{{item.status==1?'Check in':item.status==2?'Checked':item.status==4?'Recheck':item.status==5?'Recheck in':'Wait'}}</div>
                </div>
                <img v-if="checkInInfo.signList.length>0" src="@/assets/poctetTv/rewadrs/img_gift3.png" class="img_gift3"/>
            </div>
            <div class="rewards-rules">
                <div class="rewards-rules-title flexible aItem-center f24">
                    <img src="@/assets/poctetTv/rewadrs/ic_rules.png"/>
                    Check-in rules
                </div>
                <div class="rewards-rules-con f22 mt20" v-html="checkInInfo.ruleIntroduction">
                    {{checkInInfo.ruleIntroduction}}
                </div>
            </div>
        </div>
        <div class="rewards-con daily-rewards daily-all-con">
            <img src="@/assets/poctetTv/rewadrs/img_g1@2x.png" class="img_g1">
            <div class="rewards-title">
                <img src="@/assets/poctetTv/rewadrs/img_title2@2x.png"/>
            </div>
            <div class="daily-rewards-all" v-for="item in rewardlist" v-if="item.type==10">
                <div class="tip f28 f-fwb">{{item.desc}}</div>
                <div class="amount">completed {{item.attach}}/{{rewardlist.length - 1}}</div>
                <div class="rewards-btn Claimed" v-if="item.receiveInt == 3">WAIT</div>
                <div class="rewards-btn Claim" v-if="item.receiveInt==2" @click="$event.currentTarget.disabled ? '' : torewardget(item.type)" v-preventReClick>CLAIM</div>
                <div class="rewards-btn Claimed" v-if="item.receiveInt == 1">CLAIMED</div>
                <img src="@/assets/poctetTv/rewadrs/img_time@2x.png" class="img_time"/>
            </div>
        </div>
        <div class="rewards-con daily-rewards">
            <img src="@/assets/poctetTv/rewadrs/img_g1@2x.png" class="img_g1">
            <div class="taskList">
                <div class="taskItem mt20" v-for="(item, index) in rewardlist" v-if="index < rewardlist.length && item.type!=10">
                    <div class="flexible jc-between aItem-center">
                        <div class="title f28 f-fwb">{{item.desc}}</div>
                        <div class="rewards-btn toClaim" v-if="item.receiveInt == 3" @click="$event.currentTarget.disabled ? '' : toreadfun(item.type)" v-preventReClick>To Complete</div>
                        <div class="rewards-btn Claim" v-if="item.receiveInt == 2" @click="$event.currentTarget.disabled ? '' : torewardget(item.type)" v-preventReClick>CLAIM</div>
                        <div class="rewards-btn Claimed" v-if="item.receiveInt == 1">CLAIMED</div>
                    </div>
                    <div class="flexible jc-between aItem-center">
                        <div class="Bonus">
                            +<span>{{item.bonus}}</span> Bonus
                        </div>
                        <div class="time" v-if="index <= 3">completed {{item.currentReadingTime}}/{{item.attach}}mins</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="checkInPop" v-if="isSign">
            <div class="checkInPop-con">
<!--                <img class="img_pop" src="@/assets/poctetTv/rewadrs/img_pop@2x.png"/>-->
                <div class="tip f30 f-tac">Check in Reward</div>
                <div class="reward-amount f-tac f-fwb "><span>+{{getReward}}</span>Bonus</div>
                <div class="got-btn" @click="$event.currentTarget.disabled ? '' : gotFinish(0)" v-preventReClick>
                    Get
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Indicator } from 'mint-ui';
    import {signlist,signperiodic,signperiodicretroactive,rewardlist,rewardget} from '@/api/reward'
    import { getCookie } from "utils/core/kernel";
    export default {
        name: "",
        data: function () {
            return {
                isSign: false,
                checkInInfo: {},
                rewardlist: [],
                getReward: '',
                Claimtype: 1, // 1=签到；2=福利
                loading: false,
            }
        },
        mounted() {
            // VConsole 默认会挂载到 `window.VConsole` 上
            var vConsole = new window.VConsole();
            console.log(vConsole);
            console.log('zhangqi')
            this.getsignlist()
            this.getrewardlist()
        },

        methods: {
            /*签到列表*/
            getsignlist () {
                signlist().then(res=>{
                    this.checkInInfo =  res.data
                })
            },
            /*签到方法*/
            goCheck (item) {
                console.log(item.day)
                if (item.day == 7 && item.isToday && item.status == 3) {
                    this.Toast({
                        message: "You need to recheck through recharging before you get it.",
                        duration: 2000,
                        position: "center"
                    });
                } else {
                    if (item.status==2||item.status==3) {return false;}
                    if (item.status==1) {
                        this.Claimtype=1
                        signperiodic('').then(res=>{
                            console.log(res)
                            this.getReward = res.data
                            this.isHiddenBack(1)
                            this.isSign = true
                        })
                    } else if (item.status==5) {
                        this.Claimtype=1
                        signperiodicretroactive({retroactiveDay:item.day}).then(res=>{
                            console.log(res)
                            this.getReward = res.data
                            this.isHiddenBack(1)
                            this.isSign = true
                        })
                    } else if (item.status==4) {
                        const u = navigator.userAgent;
                        const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
                        //android终端
                        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                        //ios终端
                        if (isAndroid) {
                            window.jsBridge.gorecharge(JSON.stringify({day: item.day, type: 'chongzhi'}))  //安卓
                        }
                        if (isiOS) {
                            window.webkit.messageHandlers.gorecharge.postMessage({day: item.day, type: 'chongzhi'}) // 苹果
                        }
                    }
                }
            },
            /*福利列表*/
            getrewardlist () {
                rewardlist().then(res=>{
                    this.loading = false
                    let readTime = getCookie('headers')?Number(JSON.parse(getCookie('headers')).readTime):0
                    console.log(readTime)
                    if (readTime < 15) {
                        res.data.list[0].currentReadingTime = readTime
                        res.data.list[1].currentReadingTime = readTime
                        res.data.list[2].currentReadingTime = readTime
                        res.data.list[3].currentReadingTime = readTime
                    } else if (readTime >= 15 && readTime < 30) {
                        if (!res.data.list[0].receive) {
                            res.data.list[0].receiveInt = 2
                        }
                        res.data.list[0].currentReadingTime = 15
                        res.data.list[1].currentReadingTime = readTime
                        res.data.list[2].currentReadingTime = readTime
                        res.data.list[3].currentReadingTime = readTime
                    } else if (readTime >=30 && readTime < 50) {
                        if (!res.data.list[0].receive) {
                            res.data.list[0].receiveInt = 2
                        }
                        if (!res.data.list[1].receive) {
                            res.data.list[1].receiveInt = 2
                        }
                        res.data.list[0].currentReadingTime = 15
                        res.data.list[1].currentReadingTime = 30
                        res.data.list[2].currentReadingTime = readTime
                        res.data.list[3].currentReadingTime = readTime
                    } else if (readTime >= 50 && readTime < 90) {
                        if (!res.data.list[0].receive) {
                            res.data.list[0].receiveInt = 2
                        }
                        if (!res.data.list[1].receive) {
                            res.data.list[1].receiveInt = 2
                        }
                        if (!res.data.list[2].receive) {
                            res.data.list[2].receiveInt = 2
                        }
                        res.data.list[0].currentReadingTime = 15
                        res.data.list[1].currentReadingTime = 30
                        res.data.list[2].currentReadingTime = 50
                        res.data.list[3].currentReadingTime = readTime
                    } else if (readTime >= 90) {
                        if (!res.data.list[0].receive) {
                            res.data.list[0].receiveInt = 2
                        }
                        if (!res.data.list[1].receive) {
                            res.data.list[1].receiveInt = 2
                        }
                        if (!res.data.list[2].receive) {
                            res.data.list[2].receiveInt = 2
                        }
                        if (!res.data.list[3].receive) {
                            res.data.list[3].receiveInt = 2
                        }
                        res.data.list[0].currentReadingTime = 15
                        res.data.list[1].currentReadingTime = 30
                        res.data.list[2].currentReadingTime = 50
                        res.data.list[3].currentReadingTime = 90
                    }
                    this.rewardlist = res.data.list
                })
            },
            /*去完成福利*/
            toreadfun (data) {
                let type = null
                if (data == 9) {
                    type = 'chongzhi'
                } else {
                    type = 'read'
                }
                const u = navigator.userAgent;
                const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
                //android终端
                const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                //ios终端
                if (isAndroid) {
                    window.jsBridge.gorecharge(JSON.stringify({type: type}))  //安卓
                }
                if (isiOS) {
                    window.webkit.messageHandlers.gorecharge.postMessage({type: type}) // 苹果
                }
            },
            /*获取福利*/
            torewardget(data) {
                this.Claimtype=2
                rewardget({type: data}).then(res=>{
                    console.log(res)
                    this.getReward = res.data
                    this.isHiddenBack(1)
                    this.isSign = true
                    this.checkInInfo.bonus = this.checkInInfo.bonus*1 + res.data*1
                })
            },
            gotFinish (data) {
                if (this.Claimtype==1) {
                    this.getsignlist()
                } else if (this.Claimtype==2) {
                    this.getrewardlist()
                }
                this.isHiddenBack(data)
                this.isSign = false
            },
            isHiddenBack (data) {
                const u = navigator.userAgent;
                const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
                //android终端
                const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                //ios终端
                if (isAndroid) {
                    window.jsBridge.gorecharge(JSON.stringify({type: 'showNavigationBack', isHiddenBack: data}))  //安卓
                }
                if (isiOS) {
                    window.webkit.messageHandlers.gorecharge.postMessage({type: 'showNavigationBack', isHiddenBack: data}) // 苹果
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .Rewards{
        background: #1A1820;
        padding-bottom: 62px;
        letter-spacing: 0;
        .rewards-btn{
            width: 186px;
            height: 54px;
            border-radius: 29px;
            font-size: 24px;
            font-weight: bold;
            text-align: center;
            line-height: 54px;
            &.toClaim{
                background: #FFEEF4;
                border: 2px solid #E73A77;
                color: #E73A77;
            }
            &.Claim{
                background: linear-gradient(360deg, #E73A77 0%, #E8729A 100%);
                color:#fff;
            }
            &.Claimed{
                background: linear-gradient(180deg, #D6D6D6 0%, #BCBCBC 100%);
                color: #666;
            }
        }
        .rewards-yue{
            width: 100%;
            height: 280px;
            .img_rewards{
                width: 100%;
                height: 280px;
            }
        }
        .rewards-con{
            margin: 0 30px;
            display: inline-block;
            background: #FFFFFF;
            border-radius: 34px;
        }
        .rewards-title{
            text-align: center;
            margin-top: 34px;
           img{
               width: 388px;
               height: 46px;
           }
        }
        .rewards-list{
            margin-top: 30px;
            margin-right: 25px;
            .rewards-item{
                width: calc(33.3% - 25px);
                height: 244px;
                background: #D8D8D8;
                border-radius: 18px;
                text-align: center;
                position: relative;
                margin-left: 25px;
                margin-bottom: 20px;
                .rewards-day{
                    width: 90px;
                    height: 30px;
                    text-align: center;
                    line-height: 30px;
                    font-size: 22px;
                    color: #700235;
                    margin: auto;

                }
                img{
                    width: 132px;
                    height: 86px;
                }
                .rewards-money{
                    width: 160px;
                    height: 44px;
                    line-height: 44px;
                    border-radius: 22px;
                    font-size: 24px;
                    margin: auto;
                    margin-top: 16px;
                }
                .rewards-status{
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    border-radius:0 0 18px 18px;
                    font-size: 22px;
                    height: 50px;
                    color: #797979;
                    font-weight: 600;
                    line-height: 50px;
                    z-index: 2;
                }
                &.Checked-item{
                    background: #d8d8d8;
                    .rewards-day{
                        background-image: url("../../../assets/poctetTv/rewadrs/img_h@2x.png");
                        background-size: cover;
                        color: #666;
                    }
                    .rewards-money,
                    .rewards-status{
                        background: #ccc;
                        color: #666;
                    }
                }
                &.Recheck-item,
                &.Recheck-in-item{
                    background: #B7B4FF;
                    .rewards-day{
                        background-image: url("../../../assets/poctetTv/rewadrs/img_z@2x.png");
                        background-size: cover;
                        color: #333;
                    }
                    .rewards-money{
                        background: rgba(255,255,255,0.2);
                        color: #333;
                    }
                    .rewards-status{
                        background: #6700FF;
                        color: #fff;
                    }
                }
                &.Wait-item{
                    background: #F5E3FA;
                    .rewards-day{
                        background-image: url("../../../assets/poctetTv/rewadrs/img_f@2x.png");
                        background-size: cover;

                    }
                    .rewards-money{
                        background: rgba(237,173,255,0.2);
                        color: #700235;
                    }
                    .rewards-status{
                        background: rgba(236,173,254,0.4);
                        color: #700235;
                    }
                }
                &.Check-in-item{
                    width: calc(33.3% - 25px - 4px);
                    border: 2px solid #E73A77;
                    background: #F5E3FA;
                    .rewards-day{
                        background-image: url("../../../assets/poctetTv/rewadrs/img_jb@2x.png");
                        background-size: cover;
                        color: #fff;
                    }
                    .rewards-money{
                        background: rgba(237,173,255,0.2);
                        color: #700235;
                    }
                    .rewards-status{
                        background: #E73A77;
                        color: #fff;
                    }
                }
                &:nth-child(7){
                    width: calc(66.6% - 25px);
                    &.Check-in-item{
                        width: calc(66.6% - 25px - 4px) !important;
                    }
                }
            }
            .img_gift3{
                width: 172px;
                height: 210px;
                margin-left: 25px;
                margin-top: 34px;
            }
        }
        .rewards-rules{
            padding: 10px 10px 40px 30px;
            color: #333;
            .rewards-rules-title{
                img{
                    width: 30px;
                    height: 30px;
                    margin-right: 5px;
                }
            }
            .rewards-rules-con{
                line-height: 42px;
                white-space: pre-wrap;
                color: #666;
            }
        }
        .daily-rewards{
            display: inherit;
            position: relative;
            margin-top: 20px;
            &.daily-all-con{
                height: 360px;
            }
            .img_g1{
                position: absolute;
                width: 470px;
                height: 67px;
                left: 50%;
                transform: translateX(-50%);
                top: -45px;
            }
            .rewards-title{
                display: inline-block;
                width: 100%;
                margin-top: 30px;
            }
            .daily-rewards-all{
                padding-left: 50px;
                .tip{
                    color: #333;
                    font-size: 28px;
                    margin-top: 46px;
                }
                .amount{
                    font-size: 22px;
                    color: #c0c0c0;
                    margin-top: 12px;
                }
                .rewards-btn{
                    margin-top: 46px;
                }
                .img_time{
                    width: 213px;
                    height: 201px;
                    position: absolute;
                    right: 20px;
                    top: 92px;

                }
            }
        }
        .taskList{
            display: inline-block;
            width: calc(100% - 100px);
            margin:20px 0;
            padding: 0 50px;
            .taskItem{
                width: 100%;
                height: 163px;
                border-bottom: 1px solid #E6E6E6;
                color: #fff;
                &:last-child{
                    border-bottom: none;
                }
                .title{
                    color: #333;
                    margin-top: 40px;
                }
                .rewards-btn{
                    margin-top: 40px;
                }
                .time{
                    font-size: 22px;
                    color: #c0c0c0;
                    margin-top: 5px;
                }
                .Bonus{
                   font-size: 26px;
                    color: #999;
                    margin-top: 5px;
                    span{
                        color: #E73A77;
                    }
                }

            }
        }
        .checkInPop{
            top: 0;
            position: fixed;
            width: 100%;
            height: 100%;
            background: #000;
            z-index: 2;
            .checkInPop-con{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: #fff;
                width: 424px;
                height: 589px;
                background-image: url('../../../assets/poctetTv/rewadrs/img_pop.png');
                background-size: cover;
                .tip{
                    font-size: 30px;
                    color: #A77D5D;
                    margin-top: 280px;
                }
                .reward-amount{
                    font-size: 30px;
                    color: #6D2F00;
                    span{
                        font-size: 100px;
                        color: #E57365;
                    }
                }
                .got-btn{
                    width: 320px;
                    height:78px;
                    line-height: 78px;
                    text-align: center;
                    color: #fff;
                    font-size: 28px;
                    font-weight: bold;
                    background-image: url('../../../assets/poctetTv/rewadrs/btn_got@2x.png');
                    background-size: cover;
                    margin: 25px auto;
                    img{
                        width: 400px;
                        height: 80px;
                    }
                }
            }
        }
    }
</style>
